
import React from 'react';
import { Lead } from './types/LeadTypes';

interface FormFieldsProps {
  fields: Lead['formFields'];
}

const FormFields: React.FC<FormFieldsProps> = ({ fields }) => {
  if (!fields) return null;
  
  return (
    <div className="mt-4">
      <h3 className="font-medium text-gray-700 mb-2">Form Fields</h3>
      <div className="space-y-2 bg-gray-50 p-3 rounded-md">
        {fields.message && (
          <div>
            <span className="font-medium text-sm">Message: </span>
            <span className="text-sm">{fields.message}</span>
          </div>
        )}
        {fields.zipCode && (
          <div>
            <span className="font-medium text-sm">Zip Code: </span>
            <span className="text-sm">{fields.zipCode}</span>
          </div>
        )}
        {fields.email && (
          <div>
            <span className="font-medium text-sm">Email: </span>
            <span className="text-sm">{fields.email}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormFields;
